import { useState, useRef } from 'react';
import { useOutsideFocus } from '../../../../hook/useOutsideFocus';
import sum from '../../../../assets/img/svg/buttons/sum.svg';
import Button from '../../Common/Button';
import GeoSummaryDropdown from './GeoSummaryDropdown';

const ColumnOrder: React.FC = () => {
  const [openGeoSummary, setOpenGeoSummary] = useState(false);

  const menuRef = useRef<HTMLDivElement>(null);

  const openGeoSummaryDropdown = () => {
    setOpenGeoSummary((prevState) => !prevState);
  };

  useOutsideFocus(openGeoSummary, () => setOpenGeoSummary(false), menuRef);

  return (
    <div data-pw="geosum" className="geo_summary_wrapper">
      <div ref={menuRef}>
        <Button
          icon={sum}
          onClick={openGeoSummaryDropdown}
          variant={`${openGeoSummary ? 'filled' : ''}`}
          className="geo_summary_button"
        ></Button>
        <GeoSummaryDropdown showDropdown={openGeoSummary} setShowDropdown={setOpenGeoSummary} />
      </div>
    </div>
  );
};

export default ColumnOrder;
